import { useEffect, useState } from 'react';
import { ExpandableBox } from './style';
import React from 'react';

interface ExpandableContainerProps {
  children: React.ReactNode;
  initWidth: number;
  maxWidth: number;
  isOpen: boolean;
  width: number;
  setWidth: (width: number) => void;
  extraOffset?: number;
  style?: React.CSSProperties;
  bgcolor?: string;
  zIndex?: number;
  hideToggler?: boolean;
}

export default function ExpandableContainer({
  children,
  initWidth,
  maxWidth,
  isOpen,
  width,
  setWidth,
  extraOffset = 0,
  style,
  bgcolor,
  zIndex,
  hideToggler
}: ExpandableContainerProps) {
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!isDragging) return;

      const _width = e.clientX;

      if (_width < maxWidth && _width > initWidth) {
        setWidth(_width);
      }
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);

      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };
    }
  }, [isDragging, width, isOpen, initWidth, maxWidth, extraOffset]);

  const handleMouseDown = e => {
    setIsDragging(true);
  };

  return (
    <ExpandableBox
      style={{
        ...style,
        width,
        maxWidth,
        minWidth: width < initWidth ? initWidth : width,
        backgroundColor: bgcolor
      }}
    >
      <div className="container">{children}</div>

      {!hideToggler && (
        <button
          className={'splitter ' + (isDragging && 'isDragging')}
          onMouseDown={handleMouseDown}
        ></button>
      )}
    </ExpandableBox>
  );
}
